import React from 'react';
import {Divider, FormControlLabel} from '@material-ui/core';
import {IAvailableScope} from '../../../../Interfaces/interfaces';
import {
    FlexBox,
    DetailItemRow,
    DetailItemTitle,
    DetailItemDescription
} from '../../../../Shared/styles';
import {PermissionCheckbox} from './PermissionCheckbox/PermissionCheckbox';

interface IPermissionItemProps {
    appName: string;
    scope: IAvailableScope
    isOptional?: boolean
}

const PermissionItem = ({appName, scope, isOptional}: IPermissionItemProps) => (
    <>
        <DetailItemRow>
            <DetailItemTitle>{appName}</DetailItemTitle>

            <FlexBox>
                {isOptional ? (
                    <FormControlLabel
                        control={<PermissionCheckbox isActive={scope.enabledOnCurrentTenant}/>}
                        label={scope.description}
                        labelPlacement="start"
                    />
                ) : (
                    <DetailItemDescription>{scope.description}</DetailItemDescription>
                )}
            </FlexBox>
        </DetailItemRow>

        <Divider/>
    </>
)

export default PermissionItem;
